/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import { expVal } from '@atlassian/jira-feature-experiments';
import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { fg } from '@atlassian/jira-feature-gating';
import { NavigationSettingAri } from '@atlassian/ari/navigation/setting';
import type { DashboardsContentViewQueryEntrypointProps } from './DashboardsContentViewQuery.entrypoint.types.tsx';
import parameters from './__generated__/DashboardsContentViewQuery$parameters';
import type { DashboardsContentViewQuery } from './__generated__/DashboardsContentViewQuery.graphql';

type Queries = { queryRef: DashboardsContentViewQuery };

type Nav4DashboardsContentEntryPointComponent = EntryPointComponent<
	Queries,
	{},
	DashboardsContentViewQueryEntrypointProps,
	{}
>;

export const nav4DashboardsContentEntryPoint: EntryPoint<
	Nav4DashboardsContentEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<Nav4DashboardsContentEntryPointComponent>(
		/* webpackChunkName: "nav4-dashboards-content-entry-point" */ './DashboardsContentViewQuery.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),

	getPreloadProps: (params: EntryPointRouteParams) => {
		const cloudId = params.tenantContext?.cloudId || '';
		const activationId = params.tenantContext?.activationId || '';

		const entityAri = fg('navx-3660-fix-l2-l3-aris')
			? NavigationSettingAri.create({
					activationId,
					firstPartyApp: 'jira',
					settingId: 'dashboards',
					siteId: cloudId,
				}).toString()
			: JiraNavigationSettingsAri.create({
					siteId: cloudId,
					activationId,
					navigationSettingScope: 'dashboards',
				}).toString();

		const variables = expVal('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)
			? {
					cloudId,
					entityAri,
					ownerAri: IdentityUserAri.create({
						userId: params.tenantContext.atlassianAccountId || 'UNKNOWN',
					}).toString(),
					skipOrderQuery: false,
				}
			: {
					cloudId,
					entityAri: '',
					ownerAri: '',
					skipOrderQuery: true,
				};

		return {
			queries: {
				queryRef: {
					parameters,
					variables,
				},
			},
		};
	},
});
